module.exports = __webpack_public_path__ + "static/img/logo.bc92321.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/Normal13/logo.png
// module id = 43io
// module chunks = 1